export const BrandPageButtonStyles = `
:not(:disabled) {
    background: linear-gradient(105.29deg, #695CFB 7.74%, #695CFB 7.74%, #26A69A 92.26%);
    border-color: transparent;
    font-weight: 500;
    border-color: transparent !important;
  }
`;
